// How long each slide is held before the next fade begins (ms).
const HOLD_DURATION_MS = 4000;

document.querySelectorAll( '[data-slideshow-id]' ).forEach( ( el ) => {
	const slides = Array.from( el.children );
	if ( slides.length === 0 ) return;

	const fadeSpeedMs = parseInt( el.dataset.fadeSpeed, 10 ) || 1000;

	// Pass fade duration to CSS via custom property
	el.style.setProperty( '--aya-fade-speed', `${ fadeSpeedMs }ms` );
	el.classList.add( 'is-slideshow-initialized' );

	// Show the first slide immediately
	slides[ 0 ].classList.add( 'is-active' );

	// Only one slide — nothing to cycle
	if ( slides.length < 2 ) return;

	let activeIndex = 0;

	function advance() {
		const currentIndex = activeIndex;
		const nextIndex = ( currentIndex + 1 ) % slides.length;

		// Fade the next slide in on top (z-index: 2 via .is-entering)
		slides[ nextIndex ].classList.add( 'is-entering' );

		// Simultaneously fade the current slide out (z-index: 1 via .is-leaving)
		slides[ currentIndex ].classList.remove( 'is-active' );
		slides[ currentIndex ].classList.add( 'is-leaving' );

		// Once the crossfade transition finishes, clean up classes
		setTimeout( () => {
			slides[ nextIndex ].classList.remove( 'is-entering' );
			slides[ nextIndex ].classList.add( 'is-active' );
			slides[ currentIndex ].classList.remove( 'is-leaving' );
			activeIndex = nextIndex;
		}, fadeSpeedMs );
	}

	// Start the cycle: display each slide for HOLD_DURATION_MS + fadeSpeedMs total
	setInterval( advance, HOLD_DURATION_MS + fadeSpeedMs );
} );
